import { Service } from '../service.js'
import { env } from '../env.js'

class AnexosAtendimentosService extends Service {
  constructor() {
    super();
    this.url = env.baseAtendimento +'anexos-atendimentos';
  }

  async excluirAnexo(obj, controlador) {
     
    if (!obj.id) {
       toastUtils.dangerToast("Ocorreu um erro ao excluir o comentário.");
       throw new Error("Objeto não pode ser apagado pois não possúi id")
    }
    
    return await this.delete(this.url, obj, controlador);
  }
}

export const anexosAtendimentosService = new AnexosAtendimentosService();
